import React from 'react'
import { connect } from 'react-redux';
import SelectBox from 'containers/LoanApplication/components/commons/SelectBox'

class InterestType extends React.Component {

  onChange = (value) => {
    this.props.onChange(value)
  }

  render() {
    const {
      selected,
    } = this.props;

    return(
      <div>
        <div className='form-group mb-0'>
          <label>What type of interest?</label>
        </div>
        <div className='row no-gutters mb-3'>
          <div className='col-12 col-sm-3 mr-2'>
            <SelectBox
              checked={ selected == 'variable' }
              value='variable'
              text='Variable'
              onChange={ this.onChange }
             />
          </div>

          <div className='col-12 col-sm-3 mr-2'>
            <SelectBox
              checked={ selected == 'fixed' }
              value='fixed'
              text='Fixed'
              onChange={ this.onChange }
             />
          </div>

          <div className='col-12 col-sm-3 mr-2'>
            <SelectBox
              checked={ selected == 'split' }
              value='split'
              text='Split'
              onChange={ this.onChange }
             />
          </div>
        </div>
      </div>
    )
  }
}

export default InterestType;
